module.exports = __webpack_public_path__ + "img/big_11B04_yellow.f6613ad2.png";